<template>
  <div class="home">
    <!-- 新闻资讯 -->
    <div class="homeNewsBox observer-item mobileTerminal">
      <div class="borderBox">
        <div class="newsContact">
          <div class="consultTitle pc-none">
            <img src="./../assets/img/dontai.png" alt="" />
          </div>
          <div class="top contact dynamic">
            <div class="consultTitle pc-block">
              <img src="./../assets/img/资讯动态.png" alt="" />
            </div>
            <div class="contactTop">
              <ul class="consult">
                <li
                  v-for="(item, index) in dynamicListData"
                  :key="index"
                  @click="toPublicEducationDetail(item.articleId, true)"
                >
                  <img
                    :src="ipPage + item.surfacePlot"
                    width="280"
                    height="170"
                  />
                  <h5>{{ item.articleTitle }}</h5>
                  <p v-if="item.introduction">{{ item.introduction }}</p>
                  <p>
                    {{ item.indexTime && item.indexTime.split("T")[0] }}
                  </p>
                </li>
              </ul>
            </div>
            <div class="more">
              <span class="MoreContent">更多内容</span>
              <span class="line"></span>
              <span class="entrance" @click="toPublicEducationPage(177)">
                进入</span
              >
            </div>
          </div>
          <div class="consultTitle pc-none">
            <img src="./../assets/img/gongao.png" alt="" />
          </div>
          <div class="bottom contact dynamic">
            <div class="consultTitle pc-block">
              <img src="./../assets/img/通知公告.png" alt="" />
            </div>
            <div class="contactBottom">
              <ul class="ContenText">
                <li
                  v-for="(item, index) in activityAnnouncementData"
                  :key="index"
                  @click="toPublicEducationDetail(item.articleId, false)"
                >
                  <span>{{ item.articleTitle }}</span>
                  <span>
                    {{ item.indexTime && item.indexTime.split("T")[0] }}</span
                  >
                </li>
              </ul>
            </div>
            <div class="more">
              <span class="MoreContent">更多内容</span>
              <span class="line"></span>
              <span class="entrance" @click="toPublicEducationPage(176)">
                进入</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务指南 -->
    <div class="serviceDirectory mobileTerminal">
      <h4 class="fade-in">服务指南</h4>
      <p>开放时间</p>
      <div class="period fade-in">
        周二至周日免费开放 <span class="pc-none"><br></span>（周一闭馆，节假日除外）
      </div>
      <div class="openingHours fade-in">
        <div>
          {{ startTime }}
          <p class="hours">开馆时间</p>
        </div>
        <span style="margin: 0 45px">-</span>
        <div>
          {{ stopTime }}
          <p class="hours">停止入馆</p>
        </div>
        <span style="margin: 0 45px">-</span>
        <div>
          {{ closingTime }}
          <p class="hours">闭馆时间</p>
        </div>
      </div>
      <div class="serviceDirectoryBOttom fade-in">
        <ul>
          <li class="consult">咨询电话：023-40663065</li>
          <li class="consult">
            通讯地址：重庆市长寿区博物馆（重庆市长寿区桃兴三路5号）
          </li>
          <li class="consult">
            温馨提示:重庆市长寿区博物馆免费对公众开放、免预约入馆。
          </li>
        </ul>
        <div class="QRCodeBox">
          <div>
            <div class="qeBg">
              <img width="100%" src="./../assets/img/图片1.png" alt="" />
            </div>
            <p class="consult">扫一扫，关注微信公众号</p>
          </div>
          <div>
            <div class="qeBg">
              <img
                width="100%"
                height="100%"
                src="./../assets/img/bwguan2.png"
                alt=""
              />
            </div>
            <p class="consult">云上博物馆</p>
          </div>
        </div>
      </div>
    </div>
    <!--常设展览 -->

    <div class="long-termExhibition">
      <h4 class="fade-in">常设展览</h4>
      <div class="titleLine fade-in">
        <ul>
          <li
            v-for="(item, index) in termExhibition"
            :key="item.id"
            @click="exhibitClick(item, index)"
          >
            <p>{{ item.articleTitle }}</p>
            <div>
              <span
                class="connections"
                :class="{ isactive: index == checkedIndex }"
              >
                <i></i>
              </span>
              <span class="lunk one"> </span>
            </div>
          </li>
        </ul>
        <div class="articleTitle fade-in">
          {{ exhibitTitle }}
        </div>
      </div>
      <div class="articleContent dynamic">
        <img :src="surfacePlot" alt="" />
        <p>
          {{ introduction }}
        </p>
      </div>
    </div>
    <!-- 快捷入口 -->
    <!-- <div class="quickEntrance observer-item ">
      <div class=" ctentMargin">
        <div class="titleLOgo">
          <img class="" src="./../assets/img/陈列展厅.png" alt="" />
        </div>
        <div class="titleBox">
          <div
            class=" item1 "
            v-for="(it, index) in termExhibition"
            :key="it.id"
            @click="exhibitClick(it, index)"
          >
            <span
              class="articleTitle"
              :class="{ active: index == checkedIndex }"
              >{{ it.articleTitle }}</span
            >
          </div>
        </div>
        <div class="textContenImg">
          <img :src="surfacePlot" alt="" width="100%" height="100%" />
          <div class="textExhibit">
            <h3>{{ exhibitTitle }}</h3>
            <p>{{ introduction }}</p>
            <button @click="toPermanentExhibition">查看详情</button>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 临时展览 -->
    <div class="history temporaryExhibition observer-item">
      <h4 class="fade-in">临时展览</h4>
      <!-- <p class="fade-in">
        重庆曾是中华文明的重要起源地，也曾孕育了华夏民族的诞生。以重庆渭水流域为主要地区的仰韶文化，策动并实现了中国史前文化的大融合。
      </p>
      <p class="fade-in">
        龙山时代得重庆，则以超大型城址群落为代表，标志着中国进入了古国时代
      </p> -->
      <!-- Swiper -->
      <div class="swiper-button-prev btn_left pc-block"></div>
      <div class="dynamic">
        <div class="swiper mySwiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in temporaryExhibition"
              :key="index"
              @click="HistoricalResearch(item.articleId)"
            >
              <!-- <div class="hietoryTime">{{ item.createTime.split(" ")[0] }}</div>
            <div class="historyConten">{{ item.introduction }}</div> -->
              <img
                :src="ipPage + item.surfacePlot"
                height="400px"
                width="320px"
                alt=""
              />
              <!-- -->
              <div class="historyTitle">{{ item.articleTitle }}</div>
              <!-- <div
              class="historyDleat"
              :articleId="item.articleId"
              @click="HistoricalResearch(item.articleId)"
            ></div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-button-next btn_right pc-block"></div>
    </div>
    <!-- 馆藏精品 -->
    <!-- v-if="collectionData && collectionData.length > 0" -->
    <!-- <div class="allTitle  observer-item">
      <div class="titleLOgoRow">
        <img class="" src="./../assets/img/文物展示.png" alt="" />
      </div>
    </div> -->
    <div class="homeCollectionBack observer-item">
      <h4 class="fade-in">馆藏精品</h4>
      <!-- Swiper -->

      <div class="swiper-container pc-block">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(items, indexs) in collectionDataList"
            :key="indexs"
            :articleId="items.articleId"
            @click="ToCollectionDetail(items.articleId)"
          >
            <template v-if="items.childrenAdd && items.childrenAdd.length > 0">
              <div
                class="slideItem"
                v-for="keys in items.childrenAdd.slice(0, 3)"
                :key="keys.articleId"
                style="maxwidth: 233px; maxheight: 325px"
              >
                <img
                  :src="ipPage + keys.surfacePlot"
                  alt=""
                  width="100%"
                  height="100%"
                />
                <div class="title">{{ keys.articleTitle }}</div>
              </div>
            </template>
            <div class="categoryRemark fade-in">
              <div class="menuName">{{ items.menuName }}</div>
              <div class="remark">{{ items.remark }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-container pc-none">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(items, indexs) in collectionDataList"
            :key="indexs"
            :articleId="items.articleId"
            @click="ToCollectionDetail(items.articleId)"
          >
            <div class="fade-in describe">
              <div class="menuName">{{ items.menuName }}</div>
              <div class="remark">{{ items.remark }}</div>
            </div>
            <template v-if="items.childrenAdd && items.childrenAdd.length > 0">
              <div
                class="slideItem768"
                v-for="keys in items.childrenAdd.slice(0, 2)"
                :key="keys.articleId"
              >
                <img
                  :src="ipPage + keys.surfacePlot"
                  alt=""
                  width="100%"
                />
                <div class="title">{{ keys.articleTitle }}</div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="DirectionSwitching pc-block">
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";

import { articleListApi, menuTreeApi, menuListApi } from "../assets/js/api";

import { downloadByaTag } from "../assets/js/commonFun";

export default {
  name: "home", //首页
  data() {
    return {
      startTime: window.Internet.startTime,
      stopTime: window.Internet.stopTime,
      closingTime: window.Internet.closingTime,
      checkedIndex: 0,
      activeIndex: 1,
      traffic: true,
      information: true,
      exhibitTitle: "",
      surfacePlot: "",
      ipPage: sessionStorage.getItem("ips") || "",
      ewmDia: false,
      exhibitId: 0,
      introduction: "",
      /** 资讯数据 */
      newData: [],
      menuList: JSON.parse(sessionStorage.getItem("menuList")),
      /**活动公告数据 */
      activityAnnouncementData: [],
      dynamicListData: [],
      ips: sessionStorage.getItem("ips"),
      /** 藏品数据 */
      collectionData: [],
      /**临时展览 */
      temporaryExhibition: [],
      /**常设展览 */
      termExhibition: [],
      /**开放场馆 */
      openVenueList: [],
      //   历史研究
      historyListData: [],
      // 馆藏文物
      collectionDataList: [],
    };
  },
  created() {
    this.getmenuListApiFun();
    this.getPageDataFun();
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768; // 示例：判断是否为移动设备
    },
  },
  mounted() {
    let mySwiper;
    let th_is = this;
    setTimeout(() => {
      new Swiper(".swiper-container", {
        loop: true,
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 30,
        // autoplay: {
        //   delay: 2500,
        //   disableOnInteraction: false
        // },
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          click: function (swiper, even) {
            let articleId = swiper.target;
            th_is.ToCollectionDetail(articleId.getAttribute("articleId"));
          },
        },
      });
      mySwiper = new Swiper(".mySwiper", {
        slidesPerView: window.innerWidth <= 768 ? 2 : 4,
        spaceBetween: window.innerWidth <= 768 ? 10 : 60,
        speed: 1900,
        loop: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".btn_left",
          prevEl: ".btn_right",
        },
        on: {
          click: function (swiper, even) {
            let articleId = swiper.target;
            if (articleId.getAttribute("articleId")) {
              th_is.HistoricalResearch(articleId.getAttribute("articleId"));
            }
          },
        },
      });
    }, 1000);
    // dynamic 划入
    this.addAnimation(".observer-item", "visible", ".dynamic");
    this.addAnimation(".long-termExhibition", "visible", ".dynamic");
    this.addAnimation(".temporaryExhibition", "visible", ".dynamic");
    // fade-in淡入
    this.addAnimation(".serviceDirectory", "visible", ".fade-in");
    this.addAnimation(".long-termExhibition", "visible", ".fade-in");
    this.addAnimation(".temporaryExhibition", "visible", ".fade-in");
    this.addAnimation(".homeCollectionBack", "visible", ".fade-in");
  },
  methods: {
    // 添加动画
    addAnimation(name, addclass, animationClass) {
      const elements = document.querySelectorAll(name);
      const observer1 = new IntersectionObserver(this.callback);
      elements.forEach((ele) => {
        ele.classList.add("opaque");
        observer1.observe(ele);
      });
      // 创建一个观察者实例
      let observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // 检查元素是否进入了可视区
          if (entry.isIntersecting) {
            // 添加类名
            entry.target.classList.add(addclass);
          } else {
            // 移除类名
            entry.target.classList.remove(addclass);
          }
        });
      });
      // 开始观察页面上的元素
      const elementsToMonitor = document.querySelectorAll(animationClass);
      elementsToMonitor.forEach((element) => {
        observer.observe(element);
      });
    },
    // 获取馆藏精品二级菜单
    async getmenuListApiFun() {
      let { rows } = await menuListApi({ parentId: 161 });
      if (rows) {
        this.collectionDataList = rows.map((item) => {
          articleListApi({ articleType: item.uiMenuId }).then((datas) => {
            item.childrenAdd = datas.rows;
          });
          return item;
        });
      }
    },
    volunteerClick() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "volunteer",
          active: 192,
          activeName: ["志愿者之家", "jiangjiefuwu"],
        })
      );
      this.$router.push("/common/168/volunteer");
    },
    educationClick() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "educationList",
          active: 169,
          activeName: ["现场教育", "jiangjiefuwu"],
        })
      );
      this.$router.push("/common/168/educationList");
    },
    sietCLick() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "huaianMuseumSummary",
          active: 182,
          activeName: ["预约参观", "jiangjiefuwu"],
        })
      );
      this.$router.push("/common/143/huaianMuseumSummary");
    },
    contestantClick() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "huaianMuseumSummary",
          active: 145,
          activeName: ["讲解服务", "jiangjiefuwu"],
        })
      );
      this.$router.push("/common/143/huaianMuseumSummary");
    },

    callback(entries, instance) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const element = entry.target;
          element.classList.remove("opaque");
          element.classList.add("come-in");
          instance.unobserve(element);
        }
      });
    },

    exhibitClick(val, index) {
      this.checkedIndex = index;
      this.exhibitTitle = val.articleTitle;
      this.introduction = val.introduction;
      this.exhibitId = val.articleId;
      this.surfacePlot = val.surfacePlot ? this.ipPage + val.surfacePlot : "";
    },

    informationClick(value) {
      this.information = value;
      this.getPageDataFun();
    },

    /** 获取页面数据 */
    async getPageDataFun() {
      let menuTreeApiData = await menuTreeApi();
      if (menuTreeApiData.code == 200) {
        menuTreeApiData.data.forEach((item) => {
          if (item.label.indexOf("资讯") != -1) {
            item.children.forEach((key) => {
              console.log(key,'keys');
              
              if (key.label == "资讯动态") {
              // if (key.label == "新闻资讯") {
                //     /** 获取活动动态数据 */
                articleListApi({ articleType: key.id }).then((datas) => {
                  console.log(datas,'datas.rows');
                  
                  this.dynamicListData = window.innerWidth<750? datas.rows.slice(0, 1):datas.rows.slice(0, 4);
                });
              } else if (key.label == "通知公告") {
                /** 获取新闻资讯数据 */
                articleListApi({ articleType: key.id }).then((datas) => {
                  this.activityAnnouncementData = datas.rows.slice(0, 5);
                });
              }
            });
          } else if (item.label.indexOf("馆藏") != -1) {
            /** 获取典藏数据 */
            articleListApi({ articleType: item.children[0].id }).then(
              (datas) => {
                this.collectionData = datas.rows.slice(0, 6);
              }
            );
          } else if (item.label.indexOf("展览") != -1) {
            /** 获取临时展览数据 */
            item.children.forEach((key) => {
              if (key.label.indexOf("临时展览") != -1) {
                articleListApi({ articleType: key.id }).then((datas) => {
                  // this.temporaryExhibition = datas.rows.slice(0, 4);
                  this.temporaryExhibition = datas.rows;
                });
              } else if (key.label.indexOf("陈列展览") != -1) {
                articleListApi({ articleType: key.id }).then((datas) => {
                  this.termExhibition = datas.rows.slice(0, 4);
                  this.exhibitClick(this.termExhibition[0], 0);
                });
              } else if (key.label.indexOf("开放场馆") != -1) {
                articleListApi({ articleType: key.id }).then((datas) => {
                  this.openVenueList = datas.rows.slice(0, 1);
                });
              }
            });
          } else if (item.label.indexOf("研究") != -1) {
            /** 获取临时展览数据 */
            item.children.forEach((key) => {
              if (key.label.indexOf("历史研究") != -1) {
                articleListApi({ articleType: key.id }).then((datas) => {
                  this.historyListData = datas.rows;
                });
              }
            });
          }
        });
      }
    },
    /** 点击预约 */
    openCode() {
      this.ewmDia = true;
      // this.$message({
      //   showClose: true,
      //   message: "暂无预约内容！",
      // });
    },
    /**讲解服务 */
    explain() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "huaianMuseumSummary",
          active: 145,
          activeName: ["讲解服务", "jiangjiefuwu"],
        })
      );
      this.$router.push("/common/143/huaianMuseumSummary");
    },

    /**预约参观 */
    subscribe() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "huaianMuseumSummary",
          active: 182,
          activeName: ["预约参观", "yuyuecanguan"],
        })
      );
      this.$router.push("/common/143/huaianMuseumSummary");
    },
    /**跳转新闻动态页面 */
    toNewsPage() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "serviceGuide",
          active: 144,
          activeName: ["服务指南", "news dynamics"],
        })
      );
      this.$router.push("/common/143/serviceGuide");
    },
    /**跳转新闻动态详情*/
    toNewsDetail(id) {
      sessionStorage.setItem(
        "detail_obj",
        JSON.stringify({ path: "informationDetail", id: id })
      );
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "informationList",
          active: 39,
          activeName: ["新闻动态", "news dynamics"],
        })
      );
      this.$router.push({ path: `/common/19/informationDetail` });
    },
    /**跳转公共教育页面 */
    toPublicEducationPage(val) {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "informationList",
          active: val,
          activeName: ["资讯动态", "public education"],
        })
      );
      this.$router.push("/common/148/informationList");
    },

    /**跳转公共教育详情*/
    toPublicEducationDetail(id, value) {
      sessionStorage.setItem(
        "detail_obj",
        JSON.stringify({ path: "informationDetail", id: id })
      );
      let activeId = value ? 177 : 176;
      let nameMen = value ? "资讯动态" : "公示公告";
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "informationDetail",
          active: activeId,
          activeName: [nameMen, "public education"],
        })
      );
      this.$router.push({ path: `/common/148/informationDetail` });
    },
    /**跳转常设展览 */
    toPermanentExhibition() {
      sessionStorage.removeItem("ActiveObj");
      sessionStorage.setItem(
        "detail_obj",
        JSON.stringify({
          path: "exhibitionListDetail",
          id: this.exhibitId,
          activeName: ["陈列展览", "permanent exhibitions"],
        })
      );
      this.$router.push("/common/156/exhibitionListDetail");
    },
    /**跳转开放场馆 */
    toSurvey() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "informationList",
          active: 185,
          activeName: ["开放场馆", "museum introduction"],
        })
      );
      this.$router.push("/common/156/informationList");
    },
    /**跳转临时展览 */
    toTemporaryExhibition() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "exhibitionListOne",
          active: 158,
          activeName: ["临时展览", "temporary exhibition"],
        })
      );
      this.$router.push("/common/156/exhibitionListOne");
    },
    /**跳转党建 */
    toPartyBuilding() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "informationList",
          active: 114,
          activeName: ["党建", "party build"],
        })
      );
      this.$router.push("/common/19/informationList");
    },
    /**跳转服务 */
    toService() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "serviceGuide",
          active: 144,
          activeName: ["服务指南", "archaeology"],
        })
      );
      this.$router.push("/common/143/serviceGuide");
    },

    /**跳转公共教育 */
    toPublicEducation() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "informationList",
          active: 132,
          activeName: ["公共教育", "public education"],
        })
      );
      this.$router.push("/common/23/informationList");
    },
    /**跳转研究 */
    toResearch() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "reSearchList",
          active: 174,
          activeName: ["学术", "academic "],
        })
      );
      this.$router.push("/common/173/reSearchList");
    },
    /** 跳转藏品详情 */
    ToCollectionDetail(id) {
      //   sessionStorage.setItem(
      //     "detail_obj",
      //     JSON.stringify({ path: "collectionDetail", id: id })
      //   );
      sessionStorage.removeItem("ActiveObj");
      sessionStorage.setItem(
        "detail_obj",
        JSON.stringify({
          path: "collectionDetail",
          id: id,
          activeName: ["精品典藏", "book reservation"],
        })
      );
      this.$router.push({ path: `/common/161/collectionDetail` });
    },
    /** 跳转历史研究 */
    HistoricalResearch(id) {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "detail_obj",
        JSON.stringify({
          path: "exhibitionListOne",
          id: id,
          active: 158,
          activeName: ["临时展览", "book reservation"],
        })
      );
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "exhibitionListOne",
          id: id,
          active: 158,
          activeName: ["临时展览", "book reservation"],
        })
      );
      this.$router.push({ path: `/common/156/exhibitionListOne` });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-message-box__message p {
  font-size: 18px;
}
</style>
<style lang="scss" scoped>
.w1650 {
  width: 1650px;
  margin: 0 auto;
}
.w1749 {
  width: 1749px;
  margin: 0 auto;
}
.allTitle {
  text-align: center;
  color: #553d30;
  height: 254px;
  padding-top: 1px;
  background: url("./../assets/img/allTitle.png") no-repeat;
}
// 开放时间
.openTimeBox {
  margin-top: 63px;
  margin-bottom: 63px;
  display: flex;
  p {
    margin: 0;
  }
  .item {
    flex: 1;
    min-width: 0;
    padding: 0 25px;
    position: relative;
    font-size: 16px;
    line-height: 26px;
    .name {
      font-size: 22px;
      color: #333333;
      text-align: center;
    }
    .icon {
      height: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .sameP {
      margin-bottom: 12px;
    }
    &::after {
      content: "";
      clear: both;
      display: block;
      height: 170px;
      width: 1px;
      background-color: #eee;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
    }
    &:nth-last-child(1) {
      &::after {
        display: none;
      }
    }
  }
  .time {
    .label {
      width: 100px;
    }
    .text {
      flex: 1;
      min-width: 0;

      span {
        flex: 1;
        .zh {
          font-size: 14px;
        }
      }
    }
  }
  .line {
    .label {
      width: 70px;
    }
    .text {
      flex: 1;
      min-width: 0;
    }
  }
  .makeAnAppointment {
    .btn {
      width: 133px;
      margin: 0 auto;
      height: 50px;
      line-height: 50px;
      background: #553d30;
      color: #ffffff;
      border: 1px solid #553d30;
      font-size: 18px;
      text-align: center;
      box-sizing: border-box;
      cursor: pointer;
      transition: all 0.4s;
      &:hover {
        background: #fff;
        color: #553d30;
      }
    }
  }
  .wechart {
    .contact {
      text-align: center;
      .img {
        width: 174px;
        height: 174px;
        line-height: 174px;
        margin: 35px auto 15px;
        border-radius: 6px;
        border: 1px solid #553d30;
      }
    }
  }
}
// 新闻资讯
.homeNewsBox {
  padding: 84px 239px 22px 236px;
  background-repeat: no-repeat;
  box-sizing: border-box;
  background-size: cover;
  height: 1088px;
  width: 100vw;
  background: url("./../assets/img/gongaoBg.png") no-repeat;
  background-size: 100% 100%;
  .borderBox {
    box-sizing: border-box;
  }
  .newsTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    margin-bottom: 18px;

    .name {
      font-size: 24px;
      span {
        font-size: 30px;
        color: #fff;
        margin-right: 20px;
        padding-bottom: 11px;
        cursor: pointer;
      }
    }
    .more {
      font-size: 14px;
      border: 1px solid #98bfe1;
      border-radius: 19px;
      box-sizing: border-box;
      color: #fff;
      padding: 9px 14px;
      cursor: pointer;
    }
  }

  .newsContact {
    display: flex;
    height: 745px;
    flex-wrap: wrap;
    justify-content: space-between;
    .contact {
      min-width: 0;
      &.top {
        flex: 0 0 100%;
        height: 544px;
        margin-bottom: 22px;
        display: flex;
      }
      &.bottom {
        flex: 0 0 100%;
        display: flex;
        height: 423px;
        .contactBottom {
          background: url("./../assets/img/three-wire.png") no-repeat;
          background-size: 100% 100%;
          .more {
            border: 1px solid #9cc6ad;
          }
        }
      }
      .consultTitle {
        margin-right: 36px;
        img {
          transform: translateY(77px);
        }
      }
      .more {
        width: 84px;
        font-size: 20px;
        color: #4e453f;
        font-family: Microsoft YaHei;
        padding: 130px 18px 191px 18px;
        box-sizing: border-box;
        text-align: center;
        background: url("./../assets/img/genduo.png");
        span {
          display: block;
          margin: 0 auto;
          width: 30px;
        }

        .line {
          width: 1px;
          height: 50px;
          margin-top: 23px;
          margin-bottom: 17px;
          border-left: 1px dotted #8e755f;
        }
        .entrance {
          cursor: pointer;
          width: 48px;
          height: 48px;
          line-height: 48px;
          font-size: 14px;
          background: url("./../assets/img/椭圆.png") no-repeat;
          background-size: 100%;
        }
      }
      .contactTop {
        height: 544px;
        padding: 44px 48px 41px 40px;
        box-sizing: border-box;
        margin-bottom: 15px;
        position: relative;
        flex: 1;
        background: url("./../assets/img/three-wire.png") no-repeat;
        background-size: 100% 100%;
        .erweima {
          position: absolute;
          bottom: 42px;
          right: 30px;
          text-align: center;
          img {
            width: 88px;
            padding: 8px;
            box-sizing: border-box;
            border: 1px solid #7bb8b0;
          }
          p {
            font-size: 12px;
          }
        }
        .consult {
          display: flex;
          padding: 0;
          li {
            flex: 0 0 24%;
            margin-right: 11px;
            cursor: pointer;
            h5 {
              font-size: 20px;
              height: 52px;
              color: #312317;
              font-weight: 400;
              margin-bottom: 39px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              text-overflow: ellipsis; /* This is optional but often used for single-line ellipsis */
              line-height: normal; /* Adjust line-height as needed */
            }
            p {
              color: #7d7269;
              font-size: 16px;
              margin-bottom: 36px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 4;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
      .contactBottom {
        height: 423px;
        flex: 1;
        padding: 41px 49px 35px 50px;
        box-sizing: border-box;
      }
      .ContenText {
        padding: 0;
        list-style: none;
        color: #312317;
        font-size: 16px;
        // line-height: 45px;
        height: 45px;
        li {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
          flex-wrap: wrap;
        }
        span:first-child {
          flex: 1;
          margin-bottom: 10px;
          padding-right: 30px;
          min-width: 250px;
          overflow: hidden; /* 确保超出容器的文本被隐藏 */
          white-space: nowrap; /* 防止文本换行 */
          text-overflow: ellipsis; /* 超出部分显示省略号 */
        }
        span:first-child::before {
          content: "";
          width: 15px;
          height: 15px;
          line-height: 45px;
          display: inline-block;
          vertical-align: text-top;
          border-radius: 50%;
          margin-right: 13px;
          border: 1px solid #837a72;
        }
        span {
          display: inline-block;
          // max-width: 495px;

          overflow: hidden; /* 确保超出容器的文本被隐藏 */
          white-space: nowrap; /* 防止文本换行 */
          text-overflow: ellipsis; /* 超出部分显示省略号 */
          &:last-child {
            float: right;
            max-width: 90px;
          }
        }
      }
      .location {
        padding: 15px 20px 15px 20px;
        background: #f7f9fa;
        p {
          font-size: 16px;
          color: #333333;
        }
        div {
          line-height: 27px;
          font-size: 12px;
          color: #909090;
        }
      }
      .make {
        height: 122px;
        color: #fff;
        padding: 20px 20px;
        box-sizing: border-box;
        margin-top: 15px;
        background: url("./../assets/img/canguan.png") no-repeat;
        background-size: 100% 100%;
        &:last-child {
          background: url("./../assets/img/jiangjie.png") no-repeat;
          background-size: 100% 100%;
        }
        h3 {
          font-size: 20px;
          font-style: normal;
          font-weight: 400;
          margin-bottom: 0;
        }
        p {
          font-size: 14px;
          margin-top: 10px;
        }
      }
      .newItemBox {
        min-height: 518px;
        border-bottom: 1px solid #e2e8f2;
        .newItem {
          display: flex;
          align-items: center;
          padding: 19px 0;
          border-bottom: 1px solid #e8e8e8;
          &:nth-last-child(1) {
            border-bottom: none;
          }
          .newTime {
            width: 68px;
            height: 68px;
            border: 1px solid #947153;
            border-radius: 4px;
            color: #947153;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            p {
              margin: 0;
            }
            .bigSize {
              font-size: 26px;
            }
          }
          .newBody {
            flex: 1;
            padding-left: 28px;
            display: flex;
            cursor: pointer;
            min-width: 0;
            .img {
              width: 147px;
              height: 87px;
              img {
                width: 147px;
                height: 87px;
              }
            }
            .riBox {
              padding-left: 24px;
              min-width: 0;
              .title {
                font-size: 18px;
                color: #333333;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-bottom: 15px;
              }
              .txt {
                font-size: 14px;
                color: #999999;
                line-height: 24px;
                display: box;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                line-clamp: 2;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              &:hover {
                .title {
                  color: #947153;
                }
                .txt {
                  color: #947153;
                }
              }
            }
          }
        }
      }
    }
  }
}
.titleLOgo {
  margin-top: 77px;
  margin-bottom: 58px;
  text-align: center;
}
.ctentMargin {
  margin: 0 auto;
  // display: flex;
  // flex-wrap: wrap;
  padding-top: 1px;

  .titleBox {
    display: flex;
    justify-content: center;
    margin: 0 48px;
    margin-bottom: 66px;
    border-bottom: 1px solid #c2c2c2;
  }
  .item1 {
    .articleTitle {
      display: inline-block;
      width: 114px;
      height: 66px;
      line-height: 100px;
      cursor: pointer;
      text-align: center;

      background: url("./../assets/img/articleTitle.png") no-repeat;
    }
    .articleTitle.active {
      background: url("./../assets/img/articleTitleActive.png") no-repeat;
    }
  }
  .textContenImg {
    height: 840px;
    overflow: hidden;
    position: relative;
    .textExhibit {
      position: absolute;
      width: 550px;
      height: 420px;
      z-index: 3;
      padding: 50px 49px 47px 49px;
      box-sizing: border-box;
      background: #947153;
      bottom: 0;
      right: 402px;
      color: #fff;
      p {
        margin-top: 45px;
        margin-bottom: 38px;
        height: 174px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6; /* 这里的3表示最多显示6行 */
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    h3 {
      color: #fff;
      font-size: 28px;
      text-align: center;
      margin: 0;
      line-height: 28px;
    }
    button {
      padding: 0px 15px;
      width: 90px;
      height: 38px;
      line-height: 38px;
      border-radius: 19px;
      border: 1px solid #e3c9c9;
      box-sizing: border-box;
      color: #fff;
      cursor: pointer;
      background: #947153;
    }
  }
}
//快捷入口
.quickEntrance {
  min-width: 1280px;
  height: 1156px;
  background: url("./../assets/img/DisplayBg.png") no-repeat;
  background-size: 100% 100%;
  h3 {
    font-weight: normal;
    font-size: 48px;
    font-family: -G-s-k-a-0-0-h;
    color: #000000;
    line-height: 92px;
  }
  .item {
    cursor: pointer;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    border: 1px solid #ededed;
    justify-content: flex-end;
    margin-bottom: 10px;
    img {
      width: 770px;
      height: 400px;
    }
    .rightText {
      // flex: 0 0 30%;
      width: 370px;
    }
    .title {
      height: 130px;
      padding-top: 20px;
      padding-left: 20px;
      box-sizing: border-box;
      background: #fff5f5;
      .zh {
        font-size: 24px;
        color: #333333;
        line-height: 31px;
      }
      .en {
        font-family: MicrosoftYaHeiLight;
        font-size: 12px;
        color: #909090;
        line-height: 31px;
        text-align: left;
        &::after {
          content: "";
          display: block;
          width: 35px;
          height: 4px;
          background: #947153;
          margin-top: 20px;
          position: absolute;
          transform: translateX(0%);
        }
      }
    }
    .centen {
      padding: 20px 20px;
      box-sizing: border-box;
      height: calc(100% - 170px);
      position: relative;
      button {
        position: absolute;
        right: 20px;
        bottom: 0;
        padding: 10px 20px;
        color: #fff;
        border: 0;
        border-radius: 5px;
        background: #947153;
      }
    }

    &.item2 {
      .title {
        text-align: right;
        padding-right: 20px;
        .en {
          text-align: right;
          position: relative;
          &::after {
            right: 0;
          }
        }
      }
    }
  }
}
//馆藏精品
.homeCollectionBack {
  margin: 0 auto;
  position: relative;
  background: url("./../assets/img/guancang1.png") no-repeat;
  background-size: 100% 100%;
  padding: 0 380px;
  padding-right: 110px;
  height: 1300px;
  padding-top: 90px;
  box-sizing: border-box;
  h4 {
    font-family: STKaiti;
    font-weight: 400;
    font-size: 46px;
    color: #fff;
    text-align: center;
    padding-right: 233px;
  }
  .collectionTab {
    border-bottom: 1px solid #e2e8f2;
    padding: 0 70px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    margin-top: 53px;
    .tabItem {
      padding: 0 15px 14px;
      border-bottom: 2px solid transparent;
      margin: 0 10px;
      cursor: pointer;
      &.active {
        color: #6f080a;
        border-bottom: 2px solid #6f080a;
      }
    }
  }
  .collectionItemBox {
    display: flex;
    flex-wrap: wrap;
    padding-top: 85px;
    margin-bottom: 50px;
    min-height: 10px;
    .collectionItem {
      width: calc(100% / 3 - 14px);
      margin-right: 21px;
      margin-bottom: 21px;
      cursor: pointer;
      &:nth-child(3n) {
        margin-right: 0;
      }
      &:hover {
        .title {
          background-color: #947153;
          color: #ffffff;
        }
      }
      .img {
        img {
          width: 100%;
          height: 264px;
          object-fit: cover;
          vertical-align: bottom;
        }
      }
      .title {
        padding: 20px;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        background-color: #f5f6f7;
        transition: all 0.3s;
      }
    }
  }
}
@media screen and (max-width: 1640px) {
  .w1650 {
    width: 1400px;
  }
  .w1749 {
    width: 1400px;
  }
}
@media screen and (max-width: 1400px) {
  .w1650 {
    width: 1280px;
  }
  .w1749 {
    width: 1280px;
  }
  .homeCollectionBack {
    width: 1280px;
  }
}

.come-in {
  opacity: 1;
  transform: translateY(150px);
  animation: come-in 1s ease forwards;
}
.come-in:nth-child(odd) {
  animation-duration: 1s;
}

@keyframes come-in {
  100% {
    transform: translateY(0);
  }
}
.dynamic.visible {
  opacity: 0;
  animation: visibleItem 1s ease forwards;
}
.dynamic.top,
.dynamic.bottom {
  opacity: 0;
  transform: translate(-30%, 0%) matrix(1, 0, 0, 1, 0, 0);
  visibility: hidden;
}
.dynamic.bottom,
.dynamic.articleContent,
.temporaryExhibition .dynamic {
  transform: translate(30%, 0%) matrix(1, 0, 0, 1, 0, 0);
}
.fade-in {
  opacity: 0;
  // animation: visibleItem 1ms ease forwards;
}
h4 {
  font-family: "华文楷体" !important;
}
.swiper-slide-active .fade-in {
  animation: visibleItem 5s ease forwards;
}
.fade-in.visible {
  animation: visibleItem 3s ease forwards;
}
@keyframes visibleItem {
  100% {
    visibility: inherit;
    opacity: 1;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }
}
@keyframes hidelItem {
  100% {
    visibility: hidden;
    opacity: 0;
    transform: matrix(1, 0, 0, 1, 0, 0);
  }
}

.titleLOgoRow {
  margin-top: 111px;
  margin-bottom: 98px;
}
.homeCollectionBack {
  .swiper-container {
    width: 100%;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  .swiper-slide {
    text-align: center;
    font-size: 18px;
    position: relative;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    // -webkit-align-items: center;
    // align-items: center;
    transition-property: all;
    flex-wrap: wrap;

    .title {
      color: #fff;
      width: 100%;
      margin-top: 20px;
      cursor: pointer;
    }

    .slideItem:hover .title {
      animation: ction 500ms ease forwards;
    }

    @keyframes ction {
      100% {
        font-size: 22px;
        color: #dc675f;
      }
    }

    .slideItem {
      width: 233px;
      height: 325px;
      padding: 12px 13px;
      position: relative;
      box-sizing: border-box;
      &:nth-child(1) {
        top: 50%;
        left: -58px;
        transform: translateY(-109%);
      }
      &:nth-child(2) {
        top: 41%;
        left: 219px;
        left: 100px;
      }
      &:nth-child(3) {
        bottom: 0;
        left: -110px;
      }
    }
  }
}

// 历史研究
.history {
  // height: 1168px;
  padding-top: 90px;
  padding-left: 182px;
  padding-right: 145px;
  padding-bottom: 110px;
  box-sizing: border-box;
  background: url("./../assets/img/long-termExhibition.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  color: #fff;
  text-align: center;

  .logoTop {
    text-align: center;
    margin-bottom: 125px;
  }
  .btn_left {
    width: 50px;
    height: 50px;
    opacity: 0.4;
    left: 72px;
    background: url("./../assets/img/btn_l.png") no-repeat;
    background-size: 100%;
    top: 56%;
    &::after {
      display: none;
    }
    &:hover {
      animation: buttonItem 1s ease forwards;
    }
  }
  .swiper-button-next {
    width: 50px;
    right: 60px;
    height: 50px;
    opacity: 0.4;
    background: url("./../assets/img/btn_r.png") no-repeat;
    background-size: 100%;
    top: 56%;
    &::after {
      display: none;
    }
    &:hover {
      animation: buttonItem 1s ease forwards;
    }
  }
  @keyframes buttonItem {
    100% {
      transform-origin: center;
      transform: scale(1.2);
      opacity: 1;
    }
  }
  .mySwiper {
    overflow: hidden;
    margin-top: 30px;
    box-sizing: border-box;
    img {
      width: 100%;
    }
    .swiper-slide {
      .historyTitle {
        color: #fff;
        width: 100%;
        margin-top: 39px;
        cursor: pointer;
      }

      &:hover .historyTitle {
        animation: ction 500ms ease forwards;
      }

      @keyframes ction {
        100% {
          font-size: 22px;
          color: #dc675f;
        }
      }
    }
  }

  .swiper {
    width: 100%;
    height: 100%;
  }

  .gundontiao {
    position: absolute;
    height: 144px;
    width: 100%;
    background: url("./../assets/img/guntiao1.png") no-repeat left center;
    background-size: 100%;
    bottom: 22.03046vh;
    right: 0;
    z-index: 1;
    pointer-events: none;
    .shixin {
      height: 144px;
      width: 0;
      background: url("./../assets/img/gundao2.png") no-repeat left center;
      background-size: auto 100%;
      -webkit-transition: all 0.8s;
      transition: all 0.8s;
    }
  }

  // .swiper-slide {
  //   /* Center slide text vertically */
  //   //   display: -webkit-box;
  //   //   display: -ms-flexbox;
  //   //   display: -webkit-flex;
  //   -webkit-box-pack: center;
  //   -ms-flex-pack: center;
  //   -webkit-justify-content: center;
  //   justify-content: center;
  //   -webkit-box-align: center;
  //   -ms-flex-align: center;
  //   -webkit-align-items: center;
  //   align-items: center;
  //   transition: 300ms;
  //   transform: scale(0.7);
  // }
  // .swiper-slide-active,
  // .swiper-slide-duplicate-active {
  //   transform: scale(1);
  // }

  .swiper-slide {
    font-family: Microsoft YaHei;
    font-weight: 300;
    font-size: 16px;
    line-height: 32px;
    width: 419px;
    // height: 420px;
    margin-right: 210px;
    .hietoryTime {
      font-size: 28px;
      font-weight: 600;
    }

    .historyTitle {
      font-size: 20px;
      font-family: Microsoft YaHei;
      margin-top: 30px;
      font-weight: 500;
      margin-bottom: 20px;
      overflow: hidden; /* 确保超出容器的文本被隐藏 */
      white-space: nowrap; /* 防止文本换行 */
      text-overflow: ellipsis; /* 超出部分显示省略号 */
    }

    .historyConten {
      max-height: 336px;
      font-weight: 300;
      font-size: 16px;
      line-height: 32px;
      margin-bottom: 24px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      line-clamp: 10;
      -webkit-line-clamp: 10;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .historyDleat {
      width: 86px;
      height: 80px;
      font-weight: normal;
      font-size: 24px;
      color: #8c3524;
      line-height: 80px;
      float: right;
      cursor: pointer;
      background: url("./../assets/img/historyDleat.png") no-repeat;
    }
  }
}
h4 {
  font-family: STKaiti;
  font-weight: 400;
  font-size: 46px;
  margin-top: 0;
}
// 服务指南
.serviceDirectory {
  width: 100vw;
  height: 1018px;
  box-sizing: border-box;
  padding: 152px 363px 212px 360px;
  color: #fff;
  background: url("./../assets/img/serviceDirectory.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
  .period {
    font-family: Microsoft YaHei;
    font-weight: 300;
    font-size: 18px;
    color: #dec3b2;
  }

  > p {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 26px;
    color: #fff9f4;
    margin-top: 73px;
    margin-bottom: 38px;
  }
  .openingHours {
    font-family: Acumin Variable Concept;
    font-weight: 900;
    font-size: 68px;
    margin-top: 36px;
    margin-bottom: 68px;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #74655b;
    padding-bottom: 68px;
    .hours {
      font-weight: 400;
      font-size: 16px;
      text-align-last: left;
      color: #d8ccca;
    }
  }
  ul {
    padding: 0;
    margin: 0;
  }
  .consult {
    font-weight: 300;
    font-size: 14px;
    text-align: left;
    line-height: 35px;
    color: #dccec4;
  }
  .QRCodeBox {
    display: flex;
    height: 220px;
    align-items: center;
    margin-right: 51px;
    border-right: 1px solid #827064;

    > div {
      margin-right: 64px;
    }
    .qeBg {
      width: 162px;
      height: 162px;
      padding: 11px;
      box-sizing: border-box;
      background: rgba(174, 162, 150, 0.4);
    }
    .consult {
      text-align: center;
    }
  }
  .serviceDirectoryBOttom {
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
  }
}
// 常设展览
.long-termExhibition {
  width: 100vw;
  height: 1303px;
  background: url("./../assets/img/termExhibition.png") no-repeat;
  background-size: 100% 100%;
  color: #fff;
  text-align: center;
  padding-top: 89px;
  position: relative;
  .titleLine {
    position: relative;
    z-index: 3;
    ul {
      padding: 0;
      margin: 0;
      font-family: Microsoft YaHei;
      font-weight: 300;
      font-size: 16px;
      color: #c7c3bf;
      display: flex;
      justify-content: center;
      li {
        p {
          text-align-last: left;
        }
        span {
          display: inline-block;
        }
        .connections {
          border-radius: 50%;
          line-height: 9px;
          padding: 4px;
          border: 1px dotted #7a736d;
          cursor: pointer;
          i {
            display: inline-block;
            width: 10px;
            height: 10px;
            background: rgba(121, 114, 108, 0.95);
            border-radius: 50%;
          }
          &.isactive {
            background: #fff2ea;
            border-radius: 50%;
            opacity: 0.25;
          }
        }
        .lunk {
          width: 340px;
          height: 1px;
          margin-left: -25px;
          vertical-align: super;
          border-bottom: 1px solid #74655b;
          &.one {
            margin-left: -5px;
          }
        }
      }
    }
    .articleTitle {
      margin-top: 116px;
      font-family: Microsoft YaHei;
      font-weight: 300;
      font-size: 30px;
    }
  }
  .articleContent {
    padding-top: 552px;
    padding-left: 138px;
    width: 1769px;
    height: 557px;
    position: absolute;
    bottom: 224px;
    right: -140px;

    display: flex;
    background: url("./../assets/img/contentBg.png") no-repeat;
    img {
      width: 484px;
      height: 370px;
    }

    p {
      width: 646px;
      height: 220px;
      font-family: Microsoft YaHei;
      font-weight: 300;
      font-size: 20px;
      color: #654338;
      text-indent: 2em;
      text-align: left;
      margin-left: 38px;
    }
  }
}

.categoryRemark {
  writing-mode: vertical-rl;
  color: #fff;
  text-align: start;
  display: flex;
  align-items: center;
  margin-left: 340px;
  .menuName {
    font-family: "华文楷体";
    font-weight: 400;
    font-size: 36px;
    height: 210px;
    margin-bottom: 50px;
  }
  .remark {
    font-family: Microsoft YaHei;
    font-weight: 300;
    font-size: 18px;
    // min-width: 138px;
    line-height: 38px;
    height: 500px;
  }
}
.DirectionSwitching {
  position: absolute;
  top: 50%;
  right: 35%;
  width: 50px;
  height: 150px;
  .swiper-button-prev {
    width: 50px;
    height: 50px;
    top: 0;
    left: 55px;
    // opacity: 0.2;
    background: url("./../assets/img/swiper-button-prev1.png") no-repeat;
    background-size: 100%;
    &::after {
      display: none;
    }
    &:hover {
      animation: buttonItem 1s ease forwards;
    }
  }
  .swiper-button-next {
    width: 50px;
    height: 50px;
    // opacity: 0.2;
    left: 55px;
    bottom: 0;
    right: 0;
    background: url("./../assets/img/swiper-button-next1.png") no-repeat;
    background-size: 100%;
    &::after {
      display: none;
    }
    &:hover {
      animation: buttonItem 1s ease forwards;
    }
  }
  @keyframes buttonItem {
    100% {
      transform-origin: center;
      transform: scale(1.2);
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue